module.exports = __webpack_public_path__ + "img/moluscos.ec276251.svg";